import * as React from "react";

import { cn } from "@shared/lib/cn";

/*
 * То же поле, что и `Input`, но многострочное: в системе это один класс с
 * добавкой (`textarea.input`), поэтому и здесь отличий ровно два — высота в
 * три строки и растягивание только по вертикали.
 *
 * Вширь не растягивается намеренно: поле стоит в колонке своей ширины, и
 * потянутое вбок оно вылезло бы за неё.
 *
 * Капсулу оно, в отличие от однострочного, не берёт: у трёх строк скругление
 * в половину высоты съело бы первую и последнюю.
 */
function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "w-full min-w-0 min-h-[72px] resize-y px-[16px] py-[10px]",
        "rounded-[16px] border-0 bg-[color:var(--ui-sunken)]",
        "shadow-[var(--ui-field-sunk)] transition-shadow duration-200",
        "text-[14px]/[1.45] text-foreground caret-primary",
        "outline-none placeholder:text-faint",
        "focus-visible:shadow-[var(--ui-field-focus)] focus-visible:outline-none",
        "disabled:cursor-not-allowed disabled:opacity-55",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
